import { styled as muiStyled } from "@mui/material/styles";
import { Switch as MuiSwitch } from "@mui/material";

export const IOSSwitch = muiStyled((props) => (
  <MuiSwitch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))((props) => ({
  width: 56,
  height: 32,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#219653",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },

    "& .MuiSwitch-thumb": {
      content: "''",
      position: "absolute",
      left: props.checked ? "10px" : "1px",
      top: props.checked ? "2px" : "2px",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      // backgroundImage: props.checked
      //   ? `url('https://xsurface-images.s3.ap-southeast-1.amazonaws.com/Hide.svg')`
      //   : `url('https://xsurface-images.s3.ap-southeast-1.amazonaws.com/Eye.svg')`,
      "&:before": {
        content: "''",
        position: "absolute",
        width: "100%",
        height: "100%",
        left: props.checked ? "-26px" : "26px",
        top: 0,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundImage: props.checked
          ? `url('https://xsurface-images.s3.ap-southeast-1.amazonaws.com/manage_eye_1.svg')`
          : `url('https://xsurface-images.s3.ap-southeast-1.amazonaws.com/manage_eye_2.svg')`,
        // backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        //   "#fff"
        // )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
      },
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 24,
    height: 24,
  },
  "& .MuiSwitch-track": {
    borderRadius: 56 / 2,
    backgroundColor: "#D9D9D9",
    opacity: 1,
  },
}));

export const MainSwitch = muiStyled((props) => (
  <MuiSwitch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))((props) => ({
  width: 64,
  height: 32,
  padding: 0,
  "&.MuiSwitch-root": {
    margin: 0,
    marginLeft: 8,
    marginRight: 8,
  },
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(32px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "var(--primary-color)",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "var(--primary-color)",
      border: "6px solid #fff",
    },

    "& .MuiSwitch-thumb": {
      content: "''",
      position: "absolute",
      left: "1px",
      top: "1px",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 25,
    height: 25,
  },
  "& .MuiSwitch-track": {
    borderRadius: 64 / 2,
    backgroundColor: "#BABABA",
    opacity: 1,
  },
}));
